import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e11cc43e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString("ссылка:") + " ")
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sort(_ctx.filter(_ctx.events, _ctx.filter_type), _ctx.sort_type), (listItem) => {
    return (_openBlock(), _createElementBlock("div", {
      key: listItem.title
    }, [
      _createVNode(_component_ion_accordion_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_accordion, { value: "listItem.title" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, { slot: "header" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h1", null, _toDisplayString(listItem.title), 1),
                      _createElementVNode("h3", null, _toDisplayString(listItem.org), 1),
                      _createVNode(_component_ion_note, null, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.stringToDateDMY(listItem.date)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_ion_item, { slot: "content" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_note, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString("место: " + listItem.where), 1),
                          _hoisted_1,
                          _createTextVNode(" " + _toDisplayString("длительность: " + listItem.duration), 1),
                          _hoisted_2,
                          _createTextVNode(" " + _toDisplayString("для кого: " + listItem.target), 1),
                          _hoisted_3,
                          _createTextVNode(" " + _toDisplayString("сколько: " + listItem.amount), 1),
                          _hoisted_4,
                          _hoisted_5,
                          _createElementVNode("a", {
                            href: listItem.link,
                            target: "_blank"
                          }, _toDisplayString(listItem.link), 9, _hoisted_6)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024)
    ]))
  }), 128))
}